import React, { useState } from 'react';
import { Typography } from 'antd';
import './RadioImageSelector.css';
const { Paragraph, Title } = Typography;

const options = [
  {
    label: 'GTIN',
    value: 'gtin',
    img: '/images/gtin.png',
    descriptionTitle: 'BUSCAR PRODUCTOS POR CÓDIGO',
    description:
      'El código de barras proporciona un lenguaje común entre socios comerciales, cada producto tiene un código ÚNICO e INEQUÍVOCO de identificación y puede ser utilizado por todos los socios comerciales y dentro de la propia industria contribuyendo a la eficiencia del proceso de comercialización de productos. El código GS1 en cualquiera de sus estructuras, facilita la identificación de mercaderías, facilita las exportaciones y el intercambio electrónico de datos.',
  },
  {
    label: 'GLN',
    value: 'gln',
    img: '/images/gln.jpg',
    descriptionTitle: 'BUSCAR EMPRESA Y LOCALIZACION POR CÓDIGO',
    description:
      "El GLN puede ser usado para identificar a Entidades Legales o Localizaciones Físicas. A través de esta consulta Ud. podrá consultar información acerca de los GLN's otorgados a Entidades Legales como fabricantes, proveedores, clientes, bancos, universidades, etc. siempre que estás estén suscritas a GS1 Ecuador.",
  },
];

const RadioImageSelector = ({ onSelect }) => {
  const [selected, setSelected] = useState('gtin');

  const handleChange = (value) => {
    setSelected(value);
    if (onSelect) onSelect(value);
  };

  const selectedOption = options.find((opt) => opt.value === selected);

  return (
    <div>
      <div className="radio-image-group">
        {options.map((opt) => (
          <label
            key={opt.value}
            className={`radio-image-option ${
              selected === opt.value ? 'selected' : 'unselected'
            }`}
          >
            <input
              type="radio"
              name="gtin-gln"
              value={opt.value}
              checked={selected === opt.value}
              onChange={() => handleChange(opt.value)}
            />
            <img src={opt.img} alt={opt.label} />
            <span>{opt.label}</span>
          </label>
        ))}
      </div>
      {selectedOption && (
        <>
          <Title style={{ color: 'grey', marginTop: '30px' }} level={5}>
            {selectedOption.descriptionTitle}
          </Title>
          <Title style={{ marginTop: '5px' }} level={3}>
            {selectedOption.label}
          </Title>
          <Paragraph style={{ textAlign: 'justify' }}>
            {selectedOption.description}
          </Paragraph>
        </>
      )}
    </div>
  );
};

export default RadioImageSelector;
